import { safeHumans } from "@util/hvoriginsData"
import db from "./explorer/stage0.json"
import align from "./explorer/alignment.json"
import bg from "./explorer/stage1-bg.json"
import weapons from "./explorer/stage2-weapons.json"
import artifacts from "./explorer/stage3-artifacts.json"
import powers from "./explorer/stage4-powers.json"
import hash1 from "./explorer/stage0-ar.json"
import hash2 from "./explorer/stage1-ar.json"
import hash3 from "./explorer/stage2-ar.json"
import hash4 from "./explorer/stage3-ar.json"
import hash5 from "./explorer/stage4-ar.json"
import hash6 from "./explorer/stage5-ar.json"
import hash7 from "./explorer/stage6-ar.json"
import rare from "./explorer/ur.json"
import rarity from "./explorer/rarity.json"
import thumb1 from "./explorer/tn_stage_0.json"
import thumb2 from "./explorer/tn_stage_1.json"
import thumb3 from "./explorer/tn_stage_2.json"
import thumb4 from "./explorer/tn_stage_3.json"
import thumb5 from "./explorer/tn_stage_4.json"
import thumb6 from "./explorer/tn_stage_5.json"
import thumb7 from "./explorer/tn_stage_6.json"

export const getNftMetaData = nftInfo => {
  const nftData = []
  const hashes = [hash1, hash2, hash3, hash4, hash5, hash6, hash7]
  const thumbs = [thumb1, thumb2, thumb3, thumb4, thumb5, thumb6, thumb7]

  nftInfo.map(item => {
    let id = modifyId(item.id)
    let stage = item.stage
    let attributes = getAttributes(id, stage)
    let stageHashes = []
    let thumbnails = []
    for (let i = 0; i < stage; i++) {
      stageHashes.push(hashes[i][id])
      thumbnails.push(thumbs[i][id])
    }
    nftData.push({
      tokenId: item.id,
      metadata: {
        name: "Origins #" + item.id,
        attributes: attributes,
        image: "https://arweave.net/" + hashes[stage - 1][id],
        thumb_image: "https://arweave.net/" + thumbs[stage - 1][id],
        stage_hashes: stageHashes,
        thumbs: thumbnails
      },
    })
  })

  return nftData
}

export const getStakeNftMetaData = (nftInfo, type) => {
  const nftData = []

  nftInfo.map(info => {
    let id = modifyId(info.id)
    let attributes = getAttributes(id, 7)
    let status = type === "All" ? true : false
    if (!status) {
      attributes.map(attr => {
        let value = attr.value
        value = value?.toLowerCase()
        let _type = type.toLowerCase()
        if (attr.trait_type === "Alignment" && value.indexOf(_type) > -1) {
          status = true
          return
        }
      })
    }

    if (status) {
      nftData.push({
        tokenId: info.id,
        metadata: {
          name: "Origins #" + info.id,
          attributes: attributes,
          image: "https://arweave.net/" + hash7[id],
          thumb_image: "https://arweave.net/" + thumb7[id],
          stage_hashes: [
            hash1[id],
            hash2[id],
            hash3[id],
            hash4[id],
            hash5[id],
            hash6[id],
            hash7[id],
          ],
          thumbs: [
            thumb1[id],
            thumb2[id],
            thumb3[id],
            thumb4[id],
            thumb5[id],
            thumb6[id],
            thumb7[id],
          ],
          mint: info.mint,
          time: info.time,
        },
        ...info,
      })
    }
  })
  
  return nftData
}

export const getAttributes = (id, stage) => {
  let info_1 = db[id]
  let info_2 = align[id]
  let background = bg[id]
  let power = powers[id]
  let artifact = artifacts[id]
  let weapon = weapons[id]
  let attributes = []
  let alignment = null

  if (stage > 4) {
    if (power === "Invulnerability (Steel)") {
      info_1["Skin Tone"] = "Steel"
      info_1["Eye Color"] = "Blue Steel"
    }

    if (power === "Invulnerability (Stone)") {
      info_1["Skin Tone"] = "Stone"
      info_1["Eye Color"] = "Cold Stone"
    }

    if (power == "Teleportation") {
      background = "The Moon"
    }

    if (
      [
        "Scroll",
        "Stone Tablet",
        "Vial",
        "Hermetic Key",
        "Pocket Watch",
      ].includes(artifact) ||
      [
        "Undeath",
        "Super Strength",
        "Invulnerability (Steel)",
        "Invulnerability (Stone)",
        "Spectral Familiar (Rex)",
      ].includes(power)
    ) {
      if (
        ![
          "Amulet (Tech)",
          "Amulet (Norse Hammer)",
          "Bionic Eye",
          "Gas Mask",
          "Amulet (Ornamental)",
          "Mempo",
          "Amulet (Ruby)",
          "Amulet (Ancient)",
          "Amulet (Shamanic)",
        ].includes(artifact)
      ) {
        artifact = null
      }
    }
  }

  if (stage === 7) {
    alignment = info_2["Alignment"]
    if (info_2["Epic Weapon"] !== false) {
      weapon = info_2["Epic Weapon"]

      if (alignment == "Hero") {
        if (info_1["Race"] == "Elf") info_1["Race"] = "Light Elf"
        else if (info_1["Race"] == "Celestial") info_1["Race"] = "Seraphim"
        else if (info_1["Race"] == "Merfolk") info_1["Race"] = "Atlantean"
        else if (info_1["Race"] == "Demon") info_1["Race"] = "The Ascended"
        else if (info_1["Race"] == "Alien") info_1["Race"] = "The Greys"
      } else {
        if (info_1["Race"] == "Elf") info_1["Race"] = "Dark Elf"
        else if (info_1["Race"] == "Celestial") info_1["Race"] = "The Fallen"
        else if (info_1["Race"] == "Merfolk")
          info_1["Race"] = "Darkwater Merfolk"
        else if (info_1["Race"] == "Demon") info_1["Race"] = "Archdemon"
        else if (info_1["Race"] == "Alien") info_1["Race"] = "The Reptilians"
      }
    }

    if (typeof rare[id] !== "undefined") {
      attributes = rare[id]
      attributes.map(item => {
        if (item["trait_type"].indexOf("Power") === 0) {
          attributes.push({
            trait_type: "Power",
            value: item.value,
          })
        }
      })
    }
  }

  for (const [key, value] of Object.entries(info_1)) {
    if (key !== "build")
      attributes.push({
        trait_type: key,
        value: value,
      })
  }

  if (stage < 5) {
    power = null
  }
  if (stage < 4) {
    artifact = null
  }
  if (stage < 3) {
    weapon = null
  }
  if (stage < 2) {
    background = null
  }

  attributes.push(
    {
      trait_type: "Background",
      value: background,
    },
    {
      trait_type: "Alignment",
      value: alignment,
    },
    {
      trait_type: "Weapon",
      value: weapon,
    },
    {
      trait_type: "Artifact",
      value: artifact,
    },
    {
      trait_type: "Power",
      value: power,
    }
  )

  if (safeHumans.includes(id)) {
    attributes.push(
      {
        trait_type: "Organization",
        value: "S.A.F.E",
      }
    )
  }

  attributes = attributes.sort(sortString)

  let modifyAttr = []
  attributes.map((item) => {
    let trait_type = item.trait_type
    let value = item.value
    let tmp = {
      trait_type: trait_type,
      value: value,
      rarity: rarity[trait_type][value] || 0
    }
    modifyAttr.push(tmp)
  })

  modifyAttr = modifyAttr.reduce((list, current) => {
    const item = list.find(list => list.trait_type === current.trait_type);
    if (!item) {
      return list.concat([current]);
    } else {
      return list;
    }
  }, []);

  return modifyAttr
}

const sortString = (a, b) => {
  if (a.trait_type < b.trait_type) {
    return -1
  }
  if (a.trait_type > b.trait_type) {
    return 1
  }
  return 0
}

const modifyId = (id) => {
    const ids = [
    {
      original: 392,
      new: 4301
    },
    {
      original: 2291,
      new: 4615
    },
    {
      original: 945,
      new: 4821
    },
    {
      original: 2270,
      new: 4594
    },
  ]

  const result = ids.filter((item) => item.original === id)

  return result.length > 0 ? result[0].new : id
}
